export enum ExportType {
  xlsx = 'xlsx',
  csv = 'csv',
}

export interface ExportFile {
  name: string;
  buffer: any;
  type: ExportType;
  mime: string;
  configurationId?: string;
}
